import { useSetTitle } from '@/stores/title-context';
import { useLingui } from '@lingui/react/macro';
import { memberPortalCampaignsService } from '@/lib/services/member-portal-campaigns.service';
import { Navigate, getRouteApi, createFileRoute } from '@tanstack/react-router';

const routeApi = getRouteApi('/_authenticated/_app/member-portal/campaigns/by-id/$id');

/**
 * Campaign deep-link redirect for notifications.
 *
 * Notifications carry the campaign's `linkEntityId` (an ObjectId), but the
 * member-facing viewer route is slug-based (`campaigns/$slug`). This route
 * resolves id → slug via the by-id viewer endpoint and redirects, so the
 * notification bell can deep-link without changing the dispatch payload.
 *
 * Notification registry entry: `libs/notification-registry/src/route-map.ts`
 * (`campaign: '/member-portal/campaigns/by-id/:id'`).
 */
function MemberPortalCampaignByIdRedirect() {
	const { t } = useLingui();
	useSetTitle(t`Campaign`);
	const { id } = routeApi.useParams();
	const { data, isLoading, isError } = memberPortalCampaignsService.useGetViewerCampaign({ id });

	if (isLoading) {
		return <div className="p-4 text-sm text-muted-foreground">Loading...</div>;
	}
	if (isError || !data?.slug) {
		// Campaign archived, deleted, or out of audience — fall back to the list.
		return <Navigate to="/member-portal/campaigns" replace />;
	}
	return <Navigate to="/member-portal/campaigns/$slug" params={{ slug: data.slug }} replace />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/campaigns/by-id/$id')({
	component: MemberPortalCampaignByIdRedirect,
});
